/**
 * Rewrite Amazon media image URLs to a target size to avoid serving 1500px
 * images into small thumbnail slots. Amazon supports `_SL{px}_` / `_SS{px}_`
 * tokens in the filename to request a resized variant from the CDN.
 *
 * Falls back to the original URL for non-Amazon hosts or unrecognized patterns.
 */
export function resizeImageUrl(url: string | undefined | null, size: number): string {
  if (!url) return "";
  try {
    if (!/m\.media-amazon\.com|images-(na|eu|fe)\.ssl-images-amazon\.com/i.test(url)) {
      return url;
    }
    // Replace any existing _SL####_, _SS####_, _SX####_, _SY####_, _AC_SL####_ token.
    const replaced = url.replace(
      /\._(SL|SS|SX|SY|AC_SL|AC_SX|AC_SY|UL|UY|UX)\d+\./i,
      `._SL${size}_.`
    );
    if (replaced !== url) return replaced;
    // Otherwise, inject before the extension: foo.jpg -> foo._SL600_.jpg
    return url.replace(/(\.[a-zA-Z0-9]+)$/, `._SL${size}_$1`);
  } catch {
    return url;
  }
}

export function buildSrcSet(url: string | undefined | null, sizes: number[]): string {
  if (!url) return "";
  return sizes.map((s) => `${resizeImageUrl(url, s)} ${s}w`).join(", ");
}
